import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { PdfUtil } from './PdfUtil';
import { TraslateService } from 'src/app/traslate.service';
import { environment } from 'src/environments/environment';
import { ErrorStateMatcher } from '@angular/material/core';
import { NgxSpinnerService } from 'ngx-spinner';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-user-alarm-accident',
  templateUrl: './user-alarm-accident.component.html',
  styleUrls: ['./user-alarm-accident.component.scss']
})
export class UserAlarmAccidentComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('pdfTable', {static: false}) pdfTable: ElementRef;
  tableDataSource:any =[];
  collection:any =[];
  lengthpage: number=100;
  pageSizeOptions1: number[];
  pageNum: any ;
  manualPage: number =0;
  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25];
  pageSize1: any;
  pageSize: any = 10;
  index2:any=10
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected : boolean;
  ItemSelected: any[];
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  highlighted=false;
  displayedColumns = ["select","id","created_by","created_at","updated_at","action"];
  dataSource = new MatTableDataSource();
  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };
  CodePostal: any;
  Nom:any;
  Groupe: any;
  lengthTotal: any;
  Itemss: any;
  repos: any;
  entry: any;
  submitStatus: boolean;
  url: any;
  name: any;
  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  contacts10:any =['1','100'];
  id: any;
  arr: any;

  lengthItem: any =0;
  selectedRowIndex: number = -1;
  createdAt: any;
  urls: any;

  testRegisterForm: FormGroup = this.formBuilder.group({
    company_id: [],
    id: [],
    contacts: [JSON.stringify(this.contacts10)],

  });
  company: any;
  updated_at: any;
  spinnerActive: boolean=true;


  submitTestForm(){
    //console.log(this.testRegisterForm.value)



    this.http.post(environment.apiUrl+'/companies/'+JSON.parse(localStorage.getItem('currentUser')).company_id+'alarms/type/2', this.testRegisterForm.value)
    .subscribe(data => {

      //console.log(data)
     // location.reload()

    },
    (error) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Un problème est survenu! '+error,

      })

    })
  }
  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': item };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();

  }

  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }

  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }

  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }

  /** Whether the number of selected elements matches the total number of rows. */
isAllSelected() {
  const numSelected = this.selection.selected?.length;
  const numRows = this.dataSource.data?.length;
  return numSelected === numRows;
}

 /** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {

  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row =>{ this.selection.select(row); });
}

/** The label for the checkbox on the passed row */
checkboxLabel(row?: any): string {

  if (!row) {

    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

  }
  this.ItemSelected = this.selection.selected

    ////console.log(this.ItemSelected)


  return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

}

getItem(){
  this.lengthItem =this.selection.selected.length


 }

GetSelectedRow(row) {
  if(this.selectedRowIndex===row.id){
    this.selectedRowIndex=-1;
    this.selected=false;


  }else {

    this.selectedRow=row;
    this.selectedRowIndex=row.id;
    this.selected=true;

    //console.log("hello " + this.selectedRowIndex);
  }
}

public updateManualPage2(index2) {

  this.collection=[]

  //console.log(this.pageSizeOptions1)
  this.paginator.pageSize = index2

  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: index2,
    length: this.paginator.length
  });
//console.log('jjjj')


  this.lengthpage = parseInt(""+this.paginator.length/index2)

  //console.log(this.lengthpage)

   //Create dummy data
   for (var i = 0; i < this.lengthpage; i++) {
    this.collection.push(i+1);
  }

  //console.log(this.collection)

  }

public updateManualPage(index): void {
  //console.log(index)
  this.pageNum =index
  this.manualPage = index;
  this.paginator.pageIndex = index;

  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: this.paginator.pageSize,
    length: this.paginator.length
  });


}

 //filtre global

 applyFilter(event: Event) {
  this.dataSource =new MatTableDataSource(this.tableDataSource)

  const filterValue = (event.target as HTMLInputElement).value;
  //console.log( this.dataSource)
  this.dataSource.filter = filterValue.trim().toLowerCase();
}


  ngAfterViewInit() {
    this.updateManualPage2(this.index2)
  }
  constructor(private formBuilder: FormBuilder , private _snackBar: MatSnackBar ,public dialog: MatDialog ,
    private fb: FormBuilder ,private http: HttpClient,public traslateService:
    TraslateService,private spinnerAlarmAccident: NgxSpinnerService) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.spinnerActive =true
    this.spinnerAlarmAccident.show();
    this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/alarms/type/2'+ requestOptions).subscribe((response)=>{
     var listAlarms:any =response
     this.lengthTotal = listAlarms.length
     this.repos =  listAlarms;
     this.dataSource = new MatTableDataSource(this.repos);
     this.dataSource.paginator = this.paginator;
     this.tableDataSource= this.repos;
     this.dataSource.sort = this.sort;
     this.spinnerAlarmAccident.hide();
     this.spinnerActive =false
     },
     (error) => {
       Swal.fire({
         icon: 'error',
         title: 'Oops...',
         text: 'Un problème est survenu! '+error,
       })
       this.spinnerAlarmAccident.hide();
       this.spinnerActive =false
     })
  }
  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput.split(',').map(str => +str);

    }
  }
  async ngOnInit(): Promise<void> { this.firstFormGroup = this.formBuilder.group({
    firstCtrl: ['', Validators.required]
  });
  this.secondFormGroup = this.formBuilder.group({
    secondCtrl: ['', Validators.required]
  });
  this.traslateService.UserAlarmAccdataQuote.subscribe(data=>{
    this.url =data
  })
  this.urls=JSON.stringify(this.url)
  //console.log(this.urls)

  for (let entry of this.urls) {
    this.id =entry.id
    this.name =entry.company
    this.acceleration=entry.acceleration
    this.freinage=entry.braking
    this.virage=entry.turn
    this.virage_freinage=entry.turn_and_brake
    this.virage_acceleration=entry.turn_and_accelerate
    this.exces_vitesse=entry.speeding
    this.franchissement_ligne=entry.lane_crossing

  }
  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };
  this.spinnerActive =true
  //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
  this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/alarms/type/2' ,requestOptions).subscribe((response)=>{
   var listAlarms:any =response
   this.lengthTotal = listAlarms.length
   this.repos =  listAlarms
   this.dataSource = new MatTableDataSource(this.repos);
   this.dataSource.paginator = this.paginator;
   this.tableDataSource= this.repos;
   this.dataSource.sort = this.sort;

   this.spinnerActive =false
   },
   (error) => {
     Swal.fire({
       icon: 'error',
       title: 'Oops...',
       text: 'Un problème est survenu! '+error,
     })
     this.spinnerActive =false
   })
  }
 listalarm(){
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.spinnerActive =true
    this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/alarms/type/2' ,requestOptions).subscribe((response)=>{
     var listAlarms:any =response
     this.lengthTotal = listAlarms.length
     this.repos =  listAlarms
     this.dataSource = new MatTableDataSource(this.repos);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     this.spinnerActive =false

     },
     (error) => {
       Swal.fire({
         icon: 'error',
         title: 'Oops...',
         text: 'Un problème est survenu! '+error,
       })
       this.spinnerActive =false
     })
   }
openDialog() {
  this.dialog.open(DialogAddAlarmAcc,{
    disableClose: true,
    data: {
      animal: 'panda'
    },
    width: '60%',
    height: '60%',
    panelClass: 'my-custom-dialog-class'
  });
}
supprimerAlarme(){
  var array:any =[]
  this.selection.selected.forEach(el => {

    array.push(el.id);

  })
  if(array.length === 1){
    Swal.fire({
      title: "Voulez vous supprimer l'alarme selectionnée ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerActive =true
        this.spinnerAlarmAccident.show();
        this.http.delete(environment.apiUrl+'/alarms/'+JSON.stringify(array)).subscribe((response)=> {

         this.selection.clear();
         this.lengthItem =0

         this.listalarm()
        Swal.fire(
          '',
          "l'alarme a été supprimer avec succès!",
          'success'
        )
        this.spinnerAlarmAccident.hide();
        this.spinnerActive =false
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Un problème est survenu! '+error,

        })
        this.spinnerAlarmAccident.hide();
        this.spinnerActive =false
      })
    }
    })

  }
  else if (array.length>= 1){
    Swal.fire({
      title: "Voulez vous supprimer toutes les alarmes selectionnées?",
      text: "",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer!'
    }).then((result) => {
      if (result.isConfirmed) {
    //console.log(array)
    this.spinnerActive =true
    this.spinnerAlarmAccident.show();
        this.http.delete(environment.apiUrl+'/alarms/'+JSON.stringify(array)).subscribe((response)=> {
          //console.log(response)
          //console.log(environment.apiUrl+'/alarms/'+JSON.stringify(array))

          this.selection.clear();
          this.lengthItem =0
          this.listalarm()
        Swal.fire(
          '',
          "les alarmes selectionnées ont été supprimer avec succès!",
          'success'
        )
        this.spinnerAlarmAccident.hide();
        this.spinnerActive =false
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Un problème est survenu! '+error,
        })
        this.spinnerAlarmAccident.hide();
        this.spinnerActive =false
      })
      }
    })

  }
  else {
    Swal.fire({
      title: 'Veuillez selectionner un enregistrement',
      icon: 'warning',
    })
  }
}
supprimerAlarme_RightClick(e){
  Swal.fire({
    title: "Voulez vous supprimer cette l'alarme ?",
    text: "Vous êtes sur le point de supprimer cette alarme!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Annuler',
    confirmButtonText: 'Confirmer!'
  }).then((result) => {
    if (result.isConfirmed) {
      this.spinnerActive =true
      this.spinnerAlarmAccident.show();
      this.http.delete(environment.apiUrl+'/alarms/'+e).subscribe((response)=> {
        //console.log(response)
        //console.log(environment.apiUrl+'/alarms/'+e)

        this.selection.clear();
            this.lengthItem =0
            this.listalarm()
      Swal.fire(
        '',
        "l'alarme a été supprimer avec succès!",
        'success'
      )
      this.spinnerAlarmAccident.hide();
      this.spinnerActive =false
    },
    (error) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Un problème est survenu! '+error,

      })
      this.spinnerAlarmAccident.hide();
      this.spinnerActive =false
    })
    }
  })
}

afficher_info(){
  console.log(this.ItemSelected)

  if(this.ItemSelected.length === 1){
    for (let e of this.ItemSelected ) {
      this.Nom=e.created_by
      this.company=e.company
      this.createdAt=e.created_at
    }
    Swal.fire({
      imageUrl: "https://i.pinimg.com/originals/e0/43/89/e04389888734b5a55440da813f5f229f.gif",
      imageSize: '400x400',
      confirmButtonText: 'OK!',
      html:
      '<h1 class="pb-4" style="color :#3b5876;" > <strong> Details Alarme </strong>   <h1>' +
      '<h2 style="color :#3b5876;" > <strong> Nom :</strong>  '+   this.Nom +' <h2>' +
      '<h2 style="color :#3b5876;" ><strong> Companie : </strong> '+this.company+' <h2>'+
      '<h2 style="color :#3b5876;" ><strong> Date de création : </strong> '+new Date(this.createdAt).toLocaleString()+' <h2>'
    })
  }
  else if (this.ItemSelected.length >= 1) {
    Swal.fire({
      title: 'Veuillez selectionner un seul enregistrement ',
      icon: 'warning',
    })

  }
  else {

    Swal.fire({
      title: 'Veuillez selectionner un enregistrement',
      icon: 'warning',
    })

  }
}
afficher_info_RightClick(){
    for (let e of this.ItemSelected ) {
      //console.log(e.CodePostal)

      this.Groupe=e.Groupe
      this.Nom=e.name

    }
    Swal.fire({

      imageUrl: "https://lh3.googleusercontent.com/proxy/ao5MMzqhnkH_3DE451MGgDzV3jtpDyVB9Nsgh3e2fwYsyVn60R0_gttcRDKWKBgEhoOlcOzyS9qYFRVqtqgtaH6Lv6VMw-W53L9YYQgoyuLf",
      imageSize: '400x400',
      confirmButtonText: 'OK!',
      html:

      '<h1 class="pb-4" style="color :#3b5876;" > <strong> Details Alarme </strong>   <h1>' +
      '<h2 style="color :#3b5876;" > <strong> Nom :</strong>  '+   this.Nom +' <h2>' +
      '<h2 style="color :#3b5876;" ><strong> Groupe : </strong> '+this.Groupe+' <h2>'

    })
}
modifierAlarme(){
  if(this.ItemSelected.length === 1 ){

    this.ItemSelected = this.selection.selected
    this.dialog.open(DialogEditAlarmAcc,{
      disableClose: true,

      data: {
        animal: 'panda'
      },
      width: '60%',
      height: '60%',
      panelClass: 'my-custom-dialog-class'
    });
    this.traslateService.UserAlarmAccQuote.next(this.ItemSelected)


    for (let e of this.ItemSelected ) {
      //console.log(e.CodePostal)
      this.CodePostal=e.CodePostal
      this.Groupe=e.Groupe
      this.Nom=e.name

    }

  }
  else if (this.ItemSelected.length >= 1) {




    Swal.fire({
      title: 'Veuillez selectionner un seul enregistrement à modifier',
      icon: 'warning',
    })

  }
  else {




    Swal.fire({
      title: 'Veuillez selectionner un enregistrement',
      icon: 'warning',
    })

  }


}
modifierAlarme_RightClick(e){
  if(this.ItemSelected.length === 1 ){
    this.ItemSelected = this.selection.selected
    this.dialog.open(DialogAddAlarmAcc,{
      disableClose: true,

      data: {
        animal: 'panda'
      },
      width: '60%',
      height: '60%',
      panelClass: 'my-custom-dialog-class'
    });
    this.traslateService.UserAlarmAccQuote.next(this.ItemSelected)
    for (let e of this.ItemSelected ) {
      //console.log(e.CodePostal)
      this.CodePostal=e.CodePostal
      this.Groupe=e.Groupe
      this.Nom=e.name

    }

  }
  else if (this.ItemSelected.length >= 1) {
    Swal.fire({
      title: 'Veuillez selectionner un seul enregistrement à modifier',
      icon: 'warning',
    })

  }
  else {




    Swal.fire({
      title: 'Veuillez selectionner un enregistrement',
      icon: 'warning',
    })

  }



}

exportExcel(e ,e2) {


  Swal.fire({
    title: 'Souhaitez-vous  exporter la table ?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Start export file!',
    cancelButtonText: 'No, keep it'
  }).then((result) => {
    if (result.value) {
      Swal.fire(
        'Export!',
        'file is exported.',
        'success'
      )
      //console.log(e);
      e.exportTable(e2)

    } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
      Swal.fire(
        'Cancelled',
        'file not exported :)',
        'error'
      )
    }
  })

}


exportTable(){

Swal.fire({
  title: 'Souhaitez-vous  exporter la table ?',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Start export file!',
  cancelButtonText: 'No, keep it'
}).then((result) => {
  if (result.value) {


    PdfUtil.exportToPdf("ExampleTable","tbl");

} else if (result.dismiss === Swal.DismissReason.cancel) {
Swal.fire(
  'Cancelled',
  'file not exported :)',
  'error'
)
}
})

}
}


@Component({
  selector: 'dialog-elements-example-dialog',
  styleUrls: ['./user-alarm-accident.component.scss'],
  templateUrl: 'AddAlarmAcc.html',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class DialogAddAlarmAcc implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  accelerationinput:boolean=false;
  bosseinput: boolean=false;
  hors_pisteinput: boolean=false;
  franch_de_ligne_input: boolean=false;
  excesvitesseinput: boolean=false;
  freinageinput: boolean=false;
  vir_accelerationinput: boolean=false;
  vir_frein_input: boolean=false;
  virageinput: boolean=false;
  alarmActive: boolean;
  alarmtranche: boolean;


  name: any;
  entry: any;
  submitStatus: boolean;
  url: any;

  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;




  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('secondPaginator', {static: true}) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  tableDataSourceContact: any =[];
  selection = new SelectionModel<any>(true, []);
 selectedRow;
  selected : boolean;
  ItemSelected: any[];
  arr:any=[]
  repos: any;
  entryC: any;
  lengthTotal: any;

  displayedColumns: string[] = ['id', 'first_name','last_name','email','delete'];
  dataSource = new MatTableDataSource();
  matcher = new MyErrorStateMatcher();

  contacts = new FormControl();
  contactList: any="";
  new_contact: boolean;


  urlC: any;
  id: any;
  first_name: any;
  last_name: any;
  gsm: any;
  email: any;

  lengthItem: any =null;
  selectedRowIndex: number = -1;

  hiddenContact: string ='false';


  dataSourcet: any;
  myControl = new FormControl();
  selectedRowIndex2 = -1;
  displayedColumnst: string[] = ['position'];
  itemSelect2: any;
  contact_notif: any=[]
  dataSourceC= new MatTableDataSource();
  urls: any;
  contact_notif2: any=[];



  getItemDetails2(e){
    //console.log(this.contact_notif)
    this.itemSelect2 =e.id;
    this.first_name =e.first_name
    this.last_name =e.last_name

    this.email =e.email
////console.log( e)
if (!this.contact_notif.some((item) => item.id == e.id)) {
  this.contact_notif.push(e);
  //console.log(this.contact_notif)

  this.contact_notif2.push(e.id);


  //console.log(this.contact_notif2)

  this.selectedRowIndex2 = e.id;
this.hiddenContact ='jkhjk';

localStorage.setItem('contact1' ,this.contact_notif2)


var ids = localStorage.getItem('contact1')
var ids2 =ids.split(",")
//console.log(ids2)
//console.log( this.formBuilder.array(ids2) )

var test ="test"
// tslint:disable-next-line:member-ordering
this.registerForm = this.formBuilder.group({
 // tslint:disable-next-line:quotemar
 company_id: [],
 created_at: [],
 created_by: [],
 id: [],
 type: [],
 updated_at: [],

 contacts : [JSON.stringify(ids2)]

})}else {
  Swal.fire({
    position: 'center',
    icon: 'error',
    title: 'Contact déjà selectionné !',
    text:'Veillez selectionner un autre contact à notifier !',
    showConfirmButton: false,
    timer: 4000
  },  )

}

  }


  getContact_notif(){

  //console.log()

   this.dataSourceC= new MatTableDataSource(this.contact_notif);
   }

  constructor(public dialogRef: MatDialogRef<DialogAddAlarmAcc>,private _formBuilder: FormBuilder,
    public traslateService: TraslateService,private http: HttpClient,private formBuilder: FormBuilder , private _snackBar: MatSnackBar,private spinnerAlarmAccident: NgxSpinnerService ) {

    //this.getContact()
    this.getContactSelect()

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{

      var listContacts:any =response

      this.lengthTotal = listContacts.length


      this.repos =  listContacts
      ////console.log(this.repos)



      this.dataSource = new MatTableDataSource(this.repos);
     this.dataSource.paginator = this.paginator;
     this.tableDataSourceContact= this.repos;
     this.dataSource.sort = this.sort;


     },
     (error) => {
       Swal.fire({
         icon: 'error',
         title: 'Oops...',
         text: 'Un problème est survenu! '+error,

       })

     })


  }





  hiddencontenu(){
    this.hiddenContact ='true';
  }


  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();

    }


    this.hiddenContact  ='true'
  }

  public hiddencontenu2() {
    this.hiddenContact ='jkhjk';
  }


  async refrech(){

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{
     //console.log(response)
      this.contactList =  response;
      //console.log('contactList          '+this.contactList);


      this.dataSourcet = new MatTableDataSource(this.contactList) ;




this.dataSourcet.paginator = this.secondPaginator;

this._snackBar.open('la liste des contacts est actualisée ', 'Fermer', {
  duration: 2500,

});


  },
  (error) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Un problème est survenu! '+error,

    })

  })


  }


 getContactSelect(){
  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };

  this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{
   ////console.log(response)
    this.contactList =  response;
    ////console.log('contactList          '+this.contactList);


    this.dataSourcet = new MatTableDataSource(this.contactList) ;




this.dataSourcet.paginator = this.secondPaginator;




},
(error) => {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'Un problème est survenu! '+error,

  })

})

  }

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    type: [],
    updated_at: [],
    contacts : []
  })

  async ngOnInit(): Promise<void> {

    this.name=JSON.parse(localStorage.getItem('currentUser')).company

 ////console.log(name)


 this.traslateService.UserAlarmAccdataQuote.subscribe(data=>{
   this.url =data
   //console.log(data)

 })

 //console.log(this.url)
 this.urls=JSON.stringify(this.url)
 //console.log(this.urls)

 for (let entry of this.urls) {
   this.id =entry.id

   this.first_name =entry.first_name
   this.last_name =entry.last_name

   this.gsm=entry.gsm_number
   this.email=entry.email

 }

     this.firstFormGroup = this._formBuilder.group({
       firstCtrl: ['', Validators.required]
     });
     this.secondFormGroup = this._formBuilder.group({
       secondCtrl: ['', Validators.required]
     });

     this.getContactSelect()

 }



 /** Whether the number of selected elements matches the total number of rows. */
 isAllSelected() {
  const numSelected = this.selection.selected?.length;
  const numRows = this.dataSource.data?.length;
  return numSelected === numRows;
}

 /** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {

  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row =>{ this.selection.select(row); });
}



/** The label for the checkbox on the passed row */
checkboxLabel(row?: any): string {

  if (!row) {

    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

  }
  this.ItemSelected = this.selection.selected

    //console.log(this.ItemSelected)


  return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

}


getContactNotif(){
  this.lengthItem =this.selection.selected.length
  ////console.log(' contact selected   ' + this.lengthItem)

 }



GetSelectedRow(row) {
  if(this.selectedRowIndex===row.id){
    this.selectedRowIndex=-1;
    this.selected=false;


  }else {

    this.selectedRow=row;
    this.selectedRowIndex=row.id;
    this.selected=true;

    //console.log("hello " + this.selectedRowIndex);
  }
}

onNoClick(): void {
  this.dialogRef.close();
  localStorage.removeItem('contact1')
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    last_name : ['', { validators: [Validators.required,Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change" }],
    email: ['', { validators:[
      Validators.required,
      Validators.email
    ], updateOn: "change" }],

    gsm_number: [],
    first_name : ['', { validators: [Validators.required,Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change" }],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],

  })


  add_contact(){
    this.new_contact = !this.new_contact
  }

submitcontact(){

  if (this.registerFormContact.invalid) {
    return;
}
  //console.log('LKLK'+this.registerFormContact);

  Object.values(this.registerFormContact).forEach(val => {
    //console.log(val);
  });
  this.submitStatus = true;
  this.http.post(environment.apiUrl+'/companies/'+JSON.parse(localStorage.getItem('currentUser')).company_id+'/contacts', this.registerFormContact.value).subscribe(data => {
    var statuscontact:any = data
    //console.log(data)
   // location.reload()
//this.getContact()
if(statuscontact.status == 200){
  Swal.fire({
    position: 'center',
    icon: 'success',
    title: 'Contact ajouté avec succées !',
    showConfirmButton: false,
    timer: 4000
  },  )
  this.getContactSelect()
  this.registerFormContact.reset()
 }else {
  //console.log('500 status')
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: statuscontact.message+'!',
  })
 }
  },
  (error) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Un problème est survenu! '+error,
    })
  })
}
  Delete_contact(e){
    //console.log(e)

    this.getContact_notif()
localStorage.removeItem('contact1')
this.contact_notif.splice(e, 1);
this.contact_notif2.splice(e,1)
//console.log(this.contact_notif
localStorage.setItem('contact1' ,this.contact_notif2)
var ids = localStorage.getItem('contact1')
 //console.log(ids)
var ids2 =ids.split(",")
//console.log(ids2)
//console.log( this.formBuilder.array(ids2) )
 this.registerForm= this.formBuilder.group({
  // tslint:disable-next-line:quotemar
 company_id: [],
  created_at: [],
  created_by: [],
  id: [],
  type: [],
  updated_at: [],
  contacts : [JSON.stringify(ids2)]
})
  }
  select_contact(){
    this.new_contact = false
  }
    submitForm() {
      Object.values(this.registerForm).forEach(val => {
        //console.log(val);
      });
      this.submitStatus = true;
      this.http.post(environment.apiUrl+'/companies/'+JSON.parse(localStorage.getItem('currentUser')).company_id+'/alarms/type/2', this.registerForm.value).subscribe(data => {

        //console.log(data)
        var statuscontact:any = data
        if(statuscontact.status == 200){
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Alarme ajoutée avec succées !',
            showConfirmButton: false,
            timer: 2000
          },  )
   location.reload()
         }else {
          //console.log('500 status')
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: statuscontact.response+'!',

          })
         }


      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Un problème est survenu! '+error,

        })

      })
      //location.reload()
     }


enableacceleration(){
  this.accelerationinput=!this.accelerationinput
}
enablevirage(){
  this.virageinput=!this.virageinput
}
enablevir_frein(){
  this.vir_frein_input=!this.vir_frein_input
}
enableexcesvitesse(){
  this.excesvitesseinput=!this.excesvitesseinput
}
enableFreinage(){
  this.freinageinput=!this.freinageinput
}
enable_vir_acceleration(){
  this.vir_accelerationinput=!this.vir_accelerationinput
}
enable_franch_de_ligne(){
  this.franch_de_ligne_input=!this.franch_de_ligne_input
}
enablehors_piste(){
  this.hors_pisteinput=!this.hors_pisteinput
}
enablebosse(){
  this.bosseinput=!this.bosseinput
}

alarm_active_tranches(){

this.alarmtranche=true
}

alarm_tjrs_active(){
  this.alarmtranche=false
}


}
@Component({
  selector: 'dialog-elements-example-dialog',
  styleUrls: ['./user-alarm-accident.component.scss'],
  templateUrl: 'EditAlarmAcc.html',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class DialogEditAlarmAcc implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  accelerationinput:boolean=false;
  bosseinput: boolean=false;
  hors_pisteinput: boolean=false;
  franch_de_ligne_input: boolean=false;
  excesvitesseinput: boolean=false;
  freinageinput: boolean=false;
  vir_accelerationinput: boolean=false;
  vir_frein_input: boolean=false;
  virageinput: boolean=false;
  alarmActive: boolean;
  alarmtranche: boolean;
  url: any;
  name: any;



  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  submitStatus: boolean;
  id: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('secondPaginator', {static: true}) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  tableDataSourceContact: any =[];
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected : boolean;
  ItemSelected: any[];
  arr:any=[]
  repos: any;
  entryC: any;
  lengthTotal: any;
  hiddenContact: string ='false';

  displayedColumns: string[] = ['id', 'first_name','last_name','email','delete' ];
  dataSource = new MatTableDataSource();
  contacts = new FormControl();
  contactList: any="";
  new_contact: boolean;

  matcher = new MyErrorStateMatcher();

  urlC: any;
  idC: any;
  first_name: any;
  last_name: any;
  gsm: any;
  email: any;
  compagnie: any;
  lengthItem: any =null;
  selectedRowIndex: number = -1;

  dataSourcet: any;
  myControl = new FormControl();
  selectedRowIndex2 = -1;
  displayedColumnst: string[] = ['position'];
  itemSelect2: any;
  contact_notif: any=[]
  dataSourceC= new MatTableDataSource();

  contactList1: any=[];
  contact_notif1: any=[];
  contact_notif2: any=[];


  getItemDetails2(e){

    this.itemSelect2 =e.id;
    this.first_name =e.first_name
    this.last_name =e.last_name

    this.email =e.email
//console.log( e)


if (!this.contact_notif.some((item) => item.id == e.id)) {
  this.contact_notif.push(e);


  this.contact_notif2.push(e.id);

  //console.log(this.contact_notif)

this.hiddenContact ='jkhjk';
localStorage.setItem('contact1' ,this.contact_notif2)

var ids = localStorage.getItem('contact1')
var ids2 =ids.split(",")
//console.log(ids2)
//console.log( this.formBuilder.array(ids2) )


// tslint:disable-next-line:member-ordering
this.registerForm2 = this.formBuilder.group({
  // tslint:disable-next-line:quotemar

  company: [],
  company_id: [],
  created_at: [],
  created_by: [],
  id: [],

  type: [],
  updated_at: [],

  contacts : [JSON.stringify(ids2)]





 })


}
else {
  Swal.fire({
    position: 'center',
    icon: 'error',
    title: 'Contact déjà selectionné !',
    text:'Veillez selectionner un autre contact à notifier !',
    showConfirmButton: false,
    timer: 4000
  },  )

}


// this.contact_notif.push(e);
//console.log( this.contact_notif)



  }


  getContact_notif(){

  //console.log()


    this.dataSourceC= new MatTableDataSource(this.contact_notif);

   // this.ELEMENT_DATAFILTER = JSON.stringify(response)

    // this.dataSource = new MatTableDataSource(list);
    //console.log(this.dataSource)

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;





   }





  constructor(public dialogRef: MatDialogRef<DialogEditAlarmAcc>,public traslateService: TraslateService,private _formBuilder: FormBuilder,private http: HttpClient,private formBuilder: FormBuilder , private _snackBar: MatSnackBar, private spinnerAlarmAccident: NgxSpinnerService ) {
    this.traslateService.UserAlarmAccdataQuote.subscribe(data=>{
      this.url =data
      //console.log(data)
    })
    //this.getContact()
    this.getContactSelect()


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{

      var listContacts:any =response

      this.lengthTotal = listContacts.length


      this.repos =  listContacts
      //console.log(this.repos)



      this.dataSource = new MatTableDataSource(this.repos);
     this.dataSource.paginator = this.paginator;
     this.tableDataSourceContact= this.repos;
     this.dataSource.sort = this.sort;


     },
     (error) => {
       Swal.fire({
         icon: 'error',
         title: 'Oops...',
         text: 'Un problème est survenu! '+error,

       })

     })
  }

  hiddencontenu(){
    this.hiddenContact ='true';
  }

/** Whether the number of selected elements matches the total number of rows. */
isAllSelected() {
  const numSelected = this.selection.selected?.length;
  const numRows = this.dataSource.data?.length;
  return numSelected === numRows;
}

 /** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {

  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row =>{ this.selection.select(row); });
}



/** The label for the checkbox on the passed row */
checkboxLabel(row?: any): string {

  if (!row) {

    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

  }
  this.ItemSelected = this.selection.selected

    //console.log(this.ItemSelected)


  return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

}


getContactNotif(){
  this.lengthItem =this.selection.selected.length
  //console.log(' contact selected   ' + this.lengthItem)

 }



GetSelectedRow(row) {
  if(this.selectedRowIndex===row.id){
    this.selectedRowIndex=-1;
    this.selected=false;


  }else {

    this.selectedRow=row;
    this.selectedRowIndex=row.id;
    this.selected=true;

    //console.log("hello" + this.selectedRowIndex);
  }
}

applyFilter1(event: Event) {
  const filterValue2 = (event.target as HTMLInputElement).value;
  this.dataSourcet.filter = filterValue2.trim().toLowerCase();

  if (this.dataSourcet.paginator) {
    this.dataSourcet.paginator.firstPage();

  }


  this.hiddenContact  ='true'
}

public hiddencontenu2() {
  this.hiddenContact ='jkhjk';
}


async refrech(){

  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };

  this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{
   //console.log(response)
    this.contactList =  response;
    //console.log('contactList          '+this.contactList);


    this.dataSourcet = new MatTableDataSource(this.contactList) ;




this.dataSourcet.paginator = this.secondPaginator;

this._snackBar.open('la liste des contacts est actualisée ', 'Fermer', {
duration: 2500,

});


},
(error) => {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'Un problème est survenu! '+error,

  })

})


}


getContactSelect(){
const headerDict = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'Access-Control-Allow-Headers': 'Content-Type',
}

const requestOptions = {
  headers: new HttpHeaders(headerDict),
};

this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{
 ////console.log(response)
  this.contactList =  response;
  ////console.log('contactList          '+this.contactList);


  this.dataSourcet = new MatTableDataSource(this.contactList) ;




this.dataSourcet.paginator = this.secondPaginator;




},
(error) => {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'Un problème est survenu! '+error,

  })

})




}


getContactsN(e){

  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };

  this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/contacts' , requestOptions).subscribe((response)=>{
   ////console.log(response)
    this.contactList1 =  response;
    ////console.log('contactList          '+this.contactList);
    //console.log(this.contactList1)
 /*
    for (let index = 0; index < this.contactList1.length; index++)
   {
    //console.log(this.contact_notif1)
    this.contact_notif = this.contactList1[index];
    this.contact_notif.filter((x) => {
      //console.log(this.contact_notif1)
      for(let i in e.contacts){
        if (x.id === i) {

          this.contact_notif1.push(x)
        }
      }

    });


   } */
   for (let i of JSON.parse(e.contacts)) {
    //console.log(i)
    //console.log(this.contactList1)

   /*  this.contact_notif=this.contactList1.filter(element => element.id == i);

     this.contact_notif.push(element)
   */
   for (let element of this.contactList1){
    //console.log(element)

     if (element.id === i){
    //console.log(element.id)

      this.contact_notif.push(element)
      this.contact_notif2.push(element.id);

     localStorage.setItem('contact1' ,this.contact_notif2)
     }
   }
     //console.log(this.contact_notif)
  }
  this.dataSourceC= new MatTableDataSource(this.contact_notif);


  },
  (error) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Un problème est survenu! '+error,

    })

  })







}






  ngOnInit() {

    this.traslateService.UserAlarmAccdataQuote.subscribe(data=>{
      this.url =data
    })

    //console.log(this.url)

    for (let entry of this.url) {
      this.id =entry.id

      this.name =entry.company
      this.acceleration=entry.acceleration
      this.freinage=entry.braking
      this.virage=entry.turn
      this.virage_freinage=entry.turn_and_brake
      this.virage_acceleration=entry.turn_and_accelerate
      this.exces_vitesse=entry.speeding
      this.franchissement_ligne=entry.lane_crossing
      //console.log('dfgdfgdfgdf'+entry.id +entry.company); // 1, "string", false

      this.getContactsN(entry)

    }


    this.traslateService.UserAlarmAccdataQuote.subscribe(data=>{
      this.urlC =data
    })

    //console.log(this.urlC)

    for (let entry of this.url) {
      this.id =entry.id

      this.first_name =entry.first_name
      this.last_name =entry.last_name

      this.gsm=entry.gsm_number
      this.email=entry.email

      //console.log('hello'+entry.id ); // 1, "string", false


    }



    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

    this.getContactSelect()




}


registerForm2: FormGroup = this.formBuilder.group({
  // tslint:disable-next-line:quotemar

  company: [],
  company_id: [],
  created_at: [],
  created_by: [],
  id: [],



  type: [],
  updated_at: [],
  contacts:[]
})


registerFormContact: FormGroup = this.formBuilder.group({
  // tslint:disable-next-line:quotemar
  last_name : ['', { validators: [Validators.required,Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change" }],
  email: ['', { validators:[
    Validators.required,
    Validators.email
  ], updateOn: "change" }],


  gsm_number: [],
  first_name : ['', { validators: [Validators.required,Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change" }],
  company_id: [],
  created_at: [],
  created_by: [],
  id: [],
  updated_at: [],


})




applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
}
add_contact(){
  this.new_contact= !this.new_contact


}
select_contact(){

  this.new_contact=false;


}



submitcontact(){

  if (this.registerFormContact.invalid) {
    return;
}
  //console.log('LKLK'+this.registerFormContact);

  Object.values(this.registerFormContact).forEach(val => {
    //console.log(val);
  });
  this.submitStatus = true;



  this.http.post(environment.apiUrl+'/companies/'+JSON.parse(localStorage.getItem('currentUser')).company_id+'/contacts', this.registerFormContact.value).subscribe(data => {
    var statuscontact:any = data
    //console.log(data)
   // location.reload()
//this.getContact()

if(statuscontact.status == 200){
  Swal.fire({
    position: 'center',
    icon: 'success',
    title: 'Contact ajouté avec succées !',
    showConfirmButton: false,
    timer: 4000
  },  )
  this.getContactSelect()
  this.registerFormContact.reset()
 }else {
  //console.log('500 status')
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: statuscontact.message+'!',

  })
 }

  },
  (error) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Un problème est survenu! '+error,

    })

  })
  //location.reload()






}








Delete_contact(e){







//console.log(e)

this.getContact_notif()
localStorage.removeItem('contact1')
this.contact_notif.splice(e, 1);
this.contact_notif2.splice(e,1)

//console.log(this.contact_notif)

//console.log(this.contact_notif2)

localStorage.setItem('contact1' ,this.contact_notif2)





var ids = localStorage.getItem('contact1')
//console.log(ids)
// tslint:disable-next-line:member-ordering



var ids2 =ids.split(",")
//console.log(ids2)
//console.log( this.formBuilder.array(ids2) )



this.registerForm2 = this.formBuilder.group({
  // tslint:disable-next-line:quotemar

  company: [],
  company_id: [],
  created_at: [],
  created_by: [],
  id: [],

  period: [],

  type: [],
  updated_at: [],

  contacts : [JSON.stringify(ids2)]





 })








}

submitFormupdate() {



  //console.log('LKLK'+this.registerForm2.value);

  Object.values(this.registerForm2).forEach(val => {
    //console.log(val);
  });
  this.submitStatus = true;



  this.http.put(environment.apiUrl+'/alarms/'+this.id, this.registerForm2.value).subscribe(data => {

    //console.log(data)
    var statuscontact:any = data
    if(statuscontact.status == 200){
      Swal.fire({
        position: 'center',
        title: 'Modification enregistrée avec succées !',
        showConfirmButton: false,
        timer: 2000
      },  )
      location.reload()
     }else {
      //console.log('500 status')
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: statuscontact.response+'!',

      })
     }


  },
  (error) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Un problème est survenu! '+error,

    })

  })



 }


click(){


  this.compagnie =  this.compagnie.name

}
enableacceleration(){
  this.accelerationinput=!this.accelerationinput
}
enablevirage(){
  this.virageinput=!this.virageinput
}
enablevir_frein(){
  this.vir_frein_input=!this.vir_frein_input
}
enableexcesvitesse(){
  this.excesvitesseinput=!this.excesvitesseinput
}
enableFreinage(){
  this.freinageinput=!this.freinageinput
}
enable_vir_acceleration(){
  this.vir_accelerationinput=!this.vir_accelerationinput
}
enable_franch_de_ligne(){
  this.franch_de_ligne_input=!this.franch_de_ligne_input
}
enablehors_piste(){
  this.hors_pisteinput=!this.hors_pisteinput
}
enablebosse(){
  this.bosseinput=!this.bosseinput
}

alarm_active_tranches(){

this.alarmtranche=true
}

alarm_tjrs_active(){
  this.alarmtranche=false
}
onNoClick(): void {
  this.dialogRef.close();
  localStorage.removeItem('contact1')





  }
}







